import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {RequestMethod, RestService} from './rest.service';
import {Actions, ApiEndpoints} from '../constants/ApiEndpoints';
import {Router} from '@angular/router';
import {FacilityEmployee} from '../models/accr/FacilityEmployee';
import {Assignee} from '../models/accr/Assignee';
import {Partner} from '../models/res/partner';
import {StaffInformation} from '../models/accr/StaffInformation';

@Injectable()
export class OwnerService {

  constructor(
    private restService: RestService,
    private router: Router) {
  }

  private owners;
  private ownerCount: number;

  private ownersBehaviorSubject = new BehaviorSubject(null);
  private ownerCountBehaviorSubject = new BehaviorSubject(null);

  static buildOwner(item) {

    const partner = new Partner();
    partner.email = item.email;
    partner.lastName = item.lastName;
    partner.firstName = item.firstName;

    const staffInformation = new StaffInformation();
    staffInformation.ownership = item.ownership;

    const assignee = new Assignee();
    assignee.partner = partner;
    assignee.ownerType = item.ownerType;

    const owner = new FacilityEmployee();
    owner.id = item.id;
    owner.assignee = assignee;
    owner.endDate = item.endDate;
    owner.startDate = item.startDate;
    owner.staffInformation = staffInformation;

    return owner;
  }

  getOwnerCount(facilityId) {
    const url = this.router.url;
    const path = url.substr(url.indexOf('/') + 1, url.indexOf('/', url.indexOf('/') + 1) - 1);
    const endpoint = path === 'application' ? ApiEndpoints.ACCR.APPLICATION : ApiEndpoints.RES.FACILITY;
    this.restService.request<any>(RequestMethod.GET, endpoint, `${Actions.BASE_ACTIONS.READ}/employee-def/${facilityId}`)
      .subscribe(res => {
        this.ownerCount = res.data.ownerCount;
        this.updateOwnerCount(this.ownerCount);
      });
  }

  getFacilityOwners(facilityId: number) {
    this.restService.request(RequestMethod.GET, ApiEndpoints.ACCR.APPLICATION, Actions.BASE_ACTIONS.READ + `/owners/${facilityId}`)
      .subscribe(response => {
        this.owners = response?.data;
        this.ownersBehaviorSubject.next(this.owners);
      });
  }

  getOwnerCountObservable() {
    return this.ownerCountBehaviorSubject.asObservable();
  }

  getFacilityOwnersObservable() {
    return this.ownersBehaviorSubject.asObservable();
  }

  updateOwnerCount(ownerCount) {
    this.ownerCountBehaviorSubject.next(ownerCount);
  }

  getOwnersOnApplication(facility) {
    const employeeOwners = facility.employees.filter(it => it.fakeId && (it as any).isOwner) ?? [];
    (facility as any).owners?.forEach((element, index) => {
      if (employeeOwners.some(it => it.assignee.partner.email === element.assignee?.partner?.email)) {
        (facility as any).owners.splice(index, 1);
      }
    });
    return [...employeeOwners, ...((facility as any).owners ?? [])];
  }
}
